var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04377 10.5767L9.86667 7.75384L12.6896 10.5767L13.4438 9.82251L10.6209 6.99961L13.4438 4.17671L12.6896 3.42251L9.86667 6.24538L7.04377 3.42251L6.28957 4.17671L9.11243 6.99961L6.28957 9.82251L7.04377 10.5767Z",
    fill: "#D00026"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 0.599609H5.9548C5.84615 0.59979 5.73867 0.622015 5.63886 0.664941C5.53905 0.707867 5.44899 0.7706 5.37413 0.849343L0 6.52038V7.47884L5.37413 13.1499C5.44899 13.2286 5.53905 13.2914 5.63886 13.3343C5.73867 13.3772 5.84615 13.3994 5.9548 13.3996H15.2C15.4121 13.3994 15.6154 13.315 15.7654 13.165C15.9154 13.015 15.9998 12.8117 16 12.5996V1.39961C15.9998 1.18751 15.9154 0.984172 15.7654 0.834197C15.6154 0.684221 15.4121 0.599856 15.2 0.599609ZM14.9333 12.3329H6.06947L1.06667 7.05371V6.94551L6.06947 1.66628H14.9333V12.3329Z",
    fill: "#D00026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRed);
export default __webpack_public_path__ + "static/media/cross-red.ad2f77690697c648aac5b01baa3d2b43.svg";
export { ForwardRef as ReactComponent };